import type {ReactElement} from 'react';
import React from 'react';
import {BaseFilterThumbnails} from '@Panels/poster-editor-item-filters-panel/components/base-filter-thumbnails';
import {PosterEditorItemFilters} from '@Panels/poster-editor-item-filters-panel/poster-editor-item-filters-panel.types';
import type {ItemEffectsObject} from '@PosterWhiteboard/classes/item-effects.class';
import type {DeepPartial} from '@/global';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useGetSelectedSlideId} from '@Hooks/poster-editor/useGetSelectedSlideId';
import {useGetKeyFromEffectsOfActiveSlideItem} from '@Hooks/poster-editor/useGetKeyFromEffectsOfActiveSlideItem';

export function MediaSlideFiltersOptions(): ReactElement | null {
  const activeItemId = useSingleActivePosterItemId();
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const activeSlideUID = useGetSelectedSlideId();
  const activeSlide = activeSlideUID && activeItem?.isSlideshow() ? activeItem.getSelectedSlide() : null;
  const blackAndWhite = useGetKeyFromEffectsOfActiveSlideItem('blackAndWhite');
  const sepia = useGetKeyFromEffectsOfActiveSlideItem('sepia');
  const invert = useGetKeyFromEffectsOfActiveSlideItem('invert');

  if (!activeItem?.isSlideshow()) {
    return null;
  }

  if (!activeSlide?.isMediaSlide()) {
    return null;
  }

  if (blackAndWhite === undefined || sepia === undefined || invert === undefined || activeSlideUID === undefined) {
    return null;
  }

  const toggleMediaSlideFilter = (filter: PosterEditorItemFilters): void => {
    let updatedObject: DeepPartial<ItemEffectsObject> = {};
    switch (filter) {
      case PosterEditorItemFilters.BLACK_AND_WHITE:
        updatedObject = {
          blackAndWhite: !blackAndWhite,
        };
        break;
      case PosterEditorItemFilters.INVERT:
        updatedObject = {
          invert: !invert,
        };
        break;
      case PosterEditorItemFilters.SEPIA:
        updatedObject = {
          sepia: !sepia,
        };
        break;
      default:
        return;
    }

    void activeItem.updateSlideFromObject(activeSlideUID, {
      effects: updatedObject,
    });
  };

  const getOptionsForSlideshow = (): ReactElement => {
    return <BaseFilterThumbnails blackAndWhite={blackAndWhite} sepia={sepia} invert={invert} onToggleFilter={toggleMediaSlideFilter} />;
  };

  return getOptionsForSlideshow();
}
